import { resolveReferral, type ReferralReward } from "@/cart/referralCode";

/**
 * The bag pass a code on the cart earns, or undefined when it cannot be looked
 * up right now (an outage or a response that does not parse). Only a code the
 * endpoint confirms is no longer a discount earns nothing.
 */
export const lookUpReferralReward = async (
  code: string,
): Promise<ReferralReward | undefined> => {
  try {
    return (await resolveReferral(code))?.reward ?? "none";
  } catch (error) {
    console.error("Failed to look up referral reward:", error);
    return undefined;
  }
};
